import { SheetClose } from "@/components/ui/sheet";
// import { revalidatePath } from "next/cache";
import Link, { LinkProps } from "next/link";

interface RevalidateLinkProps extends LinkProps {
    revalidate?: boolean;
    children: React.ReactNode;
    className?: string;
    isMobile?: any;
    onClick?: () => void;
}

export function RevalidateLink({
    revalidate = false,
    onClick,
    isMobile,
    ...props
}: RevalidateLinkProps) {
    const handleClick = () => {
        if (revalidate) {
            // revalidatePath(props.href as string);
        }
        if (onClick) {
            onClick();
        }
    };

    return (
        <Link {...props} onClick={handleClick} className={props.className}>
            {props.children}
        </Link>
    );
}
